export const initialValues = {
  ["user_first_name"]: "",
  ["user_middle_name"]: "",
  ["user_last_name"]: "",
  ["user_phone"]: "",
  ["confirm_code"]: "",
  ["route_address_from"]: "",
  ["route_address_number_from"]: "",
  ["route_address_entrance_from"]: "",
  ["route_address_apartment_from"]: "",
};
